import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-j', 'IconLetterJ', [["path",{"d":"M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4","key":"svg-0"}]]);